<template>
  <div class='serie-item flex flex-col gap-4'>
    <template v-if="serie">
      <div class="serie-item-image">
        <div class="relative w-full aspect-[384/217] overflow-hidden rounded-8px">
          <a :href="serie.link" class="w-full h-full">
            <img
              v-lazy="serie.banner_xs.x3.url"
              :alt="serie.title"
              @load="imageLoaded = true"
              :class="['w-full h-full object-cover', { 'opacity-0': !imageLoaded }]"
            />
          </a>
        </div>
      </div>
      <div v-if="serie.serie_tag_list?.length > 1" class="serie-item-tags">
        <div class="flex flex-wrap gap-2">
          <span v-for='tag in randomTags' :key="tag" class="inline-block px-2 leading-6 rounded-[24px] text-14px text-orange-200 bg-gray-500 capitalize">
            {{ tag }}
          </span>
        </div>
      </div>

      <div class="serie-item-title text-16 leading-6">
        {{ serie.title }}
      </div>
    </template>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    serie: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      imageLoaded: false,
      randomTags: []
    }
  },
  created() {
    if (this.serie && this.serie.serie_tag_list) {
      this.randomTags = [...this.serie.serie_tag_list].sort(() => Math.random() - 0.5).slice(0, 3);
    }
  }
});
</script>